import React, { useEffect, useState } from "react";

export default function FadeIn(props) {
    const [maxIsVisible, setMaxIsVisible] = useState(0);
    const transitionDuration = props.transitionDuration || 400;
    const delay = props.delay || 50;
    const WrapperTag = props.wrapperTag || "div";
    const ChildTag = props.childTag || "div";
    const visible = typeof props.visible === "undefined" ? true : props.visible;

    useEffect(() => {
        let count = React.Children.count(props.children);
        if (!visible) {
            count = 0;
        }

        if (count === maxIsVisible) {
            const timeout = setTimeout(() => {
                if (props.onComplete) props.onComplete();
            }, transitionDuration);
            return () => clearTimeout(timeout);
        }

        const increment = count > maxIsVisible ? 1 : -1;
        const timeout = setTimeout(() => {
            setMaxIsVisible(maxIsVisible + increment);
        }, delay);
        return () => clearTimeout(timeout);
    }, [maxIsVisible, visible, props, delay, transitionDuration]);

    return (
        <WrapperTag className={props.className}>
            {React.Children.map(props.children, (child, index) => {
                if (!React.isValidElement(child)) return null;
                return (
                    <ChildTag
                        className={props.childClassName}
                        style={{
                            transition: `opacity ${transitionDuration}ms ease-out, transform ${transitionDuration}ms ease-out`,
                            opacity: index < maxIsVisible ? 1 : 0,
                            transform: index < maxIsVisible ? 'translateY(0)' : 'translateY(20px)',
                            transitionDelay: `${index * delay}ms`,
                        }}
                    >
                        {child}
                    </ChildTag>
                );
            })}
        </WrapperTag>
    );
}
